import { render, staticRenderFns } from "./SlideUpToggleTransition.vue?vue&type=template&id=7fb0a430&"
var script = {}
import style0 from "./SlideUpToggleTransition.vue?vue&type=style&index=0&id=7fb0a430&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports